export default __webpack_public_path__ + "static/media/CODE_DU_NUMERIQUE_DU BENIN_EDITION 2019_ADN.a2574146.pdf";